import { Progress } from "antd";
import React from "react";
import Spinner from "../../../../components/Spinner/Spinner";

const LoadingScreen = ({
  podPhase,
  progress,
  loadingStep,
  thumbnail,
  loadingText,
  retryInfo,
  connectionStatus
}) => {
  const getStatusColor = () => {
    if (connectionStatus === "connected") {
      return "#52c41a"; // Green
    }

    switch (podPhase) {
      case "Running":
        return connectionStatus === "connecting" ? "#faad14" : "#52c41a"; // Yellow if connecting, green if running
      case "Pending":
      case "ContainerCreating":
        return "#1890ff"; // Blue
      case "Error":
      case "Failed":
        return "#f5222d"; // Red
      default:
        return "#faad14"; // Yellow/Orange
    }
  };

  const getStatusText = () => {
    if (connectionStatus === "connecting") {
      return "Connecting to VNC";
    }
    return podPhase;
  };

  return (
    <div className="loading-container">
      <div className="loading-card">
        <div className="loading-logo">
          <img src={thumbnail} alt="thumbnail" />
        </div>
        <h2>Desktop Session</h2>
        <div className="status-indicator">
          <div className="status-badge" style={{ backgroundColor: getStatusColor() }}></div>
          <span className="status-text">{getStatusText()}</span>
        </div>

        <div className="progress-container">
          <Progress
            percent={progress}
            status={
              connectionStatus === "connected" ? "success" : progress === 100 ? "success" : "active"
            }
            strokeColor={getStatusColor()}
          />
          <p className="loading-message">{loadingText || loadingStep}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
